var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},_vm._l((_vm.title),function(item,index){return _c('span',{key:index,class:{'isActive':item.value==_vm.defaultTab},on:{"click":function($event){return _vm.changeTab(item.value)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }